import { type PrimitiveAtom, useAtom } from 'jotai'
import React from 'react'

import { type Group } from '~/utils'

import {
  GroupingPanelInner,
  type GroupingPanelInnerProps,
} from './GroupingPanelInner'

export type GroupingPanelProps = Pick<GroupingPanelInnerProps, 'disabled'> & {
  'data-testid'?: string
  groupAtom: PrimitiveAtom<Group>
}

export const GroupingPanel = ({
  'data-testid': dataTestId = 'components-features-grouping-panel',
  groupAtom,
  ...rest
}: GroupingPanelProps) => {
  const [group, setGroup] = useAtom(groupAtom)

  return (
    <GroupingPanelInner
      {...rest}
      data-testid={dataTestId}
      group={group}
      onChange={setGroup}
    />
  )
}
